<template>
  <section v-if="host" class="poster-host">
    <div class="poster-host-head">
      <img v-if="host.profile_image" :src="host.profile_image" alt="" class="poster-host-logo">
      <div class="poster-host-who">
        <h2 class="poster-host-name">{{ host.name }}</h2>
        <p v-if="host.title" class="poster-host-title">{{ host.title }}</p>
      </div>
      <div v-if="links.length" class="poster-host-links">
        <a
          v-for="link in links"
          :key="link.label"
          :href="link.href"
          :aria-label="link.label"
          class="poster-host-link"
          target="_blank"
          rel="noopener"
        >
          <img :src="link.icon" :alt="link.label" width="22" height="22">
        </a>
      </div>
    </div>
    <PosterClamp v-if="host.about" class="poster-host-more" :lines="2" :lineHeight="24">
      <p class="poster-host-about">{{ host.about }}</p>
    </PosterClamp>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import PosterClamp from './PosterClamp';

// The same icons PresentUserInfo shows.
const ICONS = {
  Facebook: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FFacebook_Logo_Primary.png?alt=media&token=2731adce-75a0-493d-ac5d-94a2913b2aa4',
  Instagram: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FInstagram_Glyph_Gradient.png?alt=media&token=67820264-b94c-48d9-b2fc-e1a6acda27d2',
  Website: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FURLIcon.png?alt=media&token=010bba69-2e1c-4284-9f13-e6c5e8612cc8',
};

/**
 * The poster design's ride manager card: logo, name, title and links on one
 * row, and the "about" text cut to two lines. The data is PresentUserInfo's
 * (presentUserInfo store, fetched with the ride page).
 */
export default {
  name: 'PosterHostCard',
  components: { PosterClamp },
  computed: {
    ...mapGetters('presentUserInfo', { host: 'userExtraInformation' }),
    links() {
      const host = this.host || {};
      return [
        { label: 'Facebook', href: host.facebook_link },
        { label: 'Instagram', href: host.instagram_link },
        { label: 'Website', href: host.website_link },
      ].filter(link => link.href).map(link => Object.assign(link, { icon: ICONS[link.label] }));
    },
  },
};
</script>

<style scoped>
.poster-host {
  max-width: 760px;
  margin: 0 auto 20px;
  padding: 16px 18px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 8px 24px -16px rgba(0, 0, 0, 0.35);
}

.poster-host-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.poster-host-logo {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px rgba(0, 0, 0, 0.08);
}

.poster-host-who {
  flex: 1;
  min-width: 0;
}

.poster-host-name {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
  color: #1d1d1f;
}

.poster-host-title {
  margin: 2px 0 0;
  font-size: 14px;
  line-height: 1.35;
  color: #6e6e73;
}

.poster-host-links {
  display: flex;
  gap: 6px;
}

.poster-host-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #f2f2f4;
  transition: transform 0.2s ease;
}

@media (hover: hover) {
  .poster-host-link:hover {
    transform: translateY(-1px);
  }
}

.poster-host-more {
  margin-top: 12px;
}

/* No margin inside the clamp: it would eat into the two lines it shows. */
.poster-host-about {
  margin: 0;
  font-size: 15px;
  line-height: 24px !important;
  color: #3a3a3c;
  white-space: pre-line;
}
</style>
